module.exports = __webpack_public_path__ + "img/5.32d256b6.png";